import { z } from 'zod';
import { CopyGenerationInputSchema, CopyGenerationOutputItemSchema, } from './copy-generation.widget.schema';
export const CopyGenerationWidgetKey = 'copy-generation-widget:v1';
export const CopyGenerationWidgetKind = 'copy';
/** Server-owned key prefix for saved copy-generation outputs. */
export const SAVED_COPY_ARTIFACT_KEY_PREFIX = 'saved-copy:';
export const CopyGenerationWidgetSchema = z.object({
    title: z.string().describe('The title of the copy generation widget'),
    items: z.array(CopyGenerationOutputItemSchema).describe('The list of generated copy texts'),
    settings: CopyGenerationInputSchema,
    createdAt: z.date().describe('Timestamp when the copy was generated'),
});
